import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "statistics" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center" }, "Statistik", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "flex md2 filteringBox" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mt-2" }, "Filtrering", -1)
const _hoisted_6 = { class: "name filterItem" }
const _hoisted_7 = { class: "row justify--center mb-2 mt-2" }
const _hoisted_8 = { class: "season filterItem" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Sæson")
], -1)
const _hoisted_10 = { class: "tournament filterItem" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Turneringskategori")
], -1)
const _hoisted_12 = { class: "series filterItem" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Niveau")
], -1)
const _hoisted_14 = { class: "clubs filterItem" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Klubber")
], -1)
const _hoisted_16 = { class: "gender filterItem" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Køn")
], -1)
const _hoisted_18 = { class: "age filterItem" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Alder")
], -1)
const _hoisted_20 = { class: "resetFilter filterItem" }
const _hoisted_21 = { class: "row justify--center" }
const _hoisted_22 = { class: "flex md9 tableBox center" }
const _hoisted_23 = { class: "va-table-responsive" }
const _hoisted_24 = { class: "va-table--striped statisticsTable va-table" }
const _hoisted_25 = { class: "center" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "center" }
const _hoisted_28 = { class: "center" }
const _hoisted_29 = { class: "center" }
const _hoisted_30 = { class: "center" }
const _hoisted_31 = { class: "center" }
const _hoisted_32 = { class: "center" }
const _hoisted_33 = { class: "center" }
const _hoisted_34 = { class: "center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_option_list = _resolveComponent("va-option-list")!
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_va_input, {
            label: "Søg Medlemmer og Licens",
            onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.searchMembers()), ["enter"])),
            type: "text",
            modelValue: _ctx.searchTerm,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_button, {
              size: "small",
              class: "center",
              rounded: false,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchMembers())),
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_va_option_list, {
            modelValue: _ctx.seasonValue,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.seasonValue) = $event)),
            options: _ctx.seasonOptions,
            "text-by": (option) => option.name
          }, null, 8, ["modelValue", "options", "text-by"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_va_option_list, {
            modelValue: _ctx.tournamentValue,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tournamentValue) = $event)),
            options: _ctx.tournamentOptions,
            "text-by": (option) => option.name
          }, null, 8, ["modelValue", "options", "text-by"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_va_option_list, {
            class: "seriesList",
            modelValue: _ctx.seriesValue,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.seriesValue) = $event)),
            options: _ctx.seriesOptions,
            "text-by": (option) => option.name
          }, null, 8, ["modelValue", "options", "text-by"])
        ], 512), [
          [_vShow, _ctx.tournamentValue.length ===  1 && _ctx.seasonValue.length === 1]
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_va_select, {
            class: "clubOptions",
            modelValue: _ctx.clubValue,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.clubValue) = $event)),
            options: _ctx.clubOptions,
            "track-by": (option) => option.id,
            "text-by": (option) => option.name,
            multiple: "",
            searchable: "",
            clearable: "",
            bordered: "",
            label: "Vælg klubber",
            "no-options-text": "Ingen klubber"
          }, null, 8, ["modelValue", "options", "track-by", "text-by"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_va_option_list, {
            modelValue: _ctx.genderValue,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.genderValue) = $event)),
            options: _ctx.genderOptions,
            "text-by": (option) => option.name
          }, null, 8, ["modelValue", "options", "text-by"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_va_input, {
            class: "ageOptions",
            type: "number",
            label: _ctx.ageParameter[0].name,
            modelValue: _ctx.ageParameter[0].age,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ageParameter[0].age) = $event)),
            clearable: "",
            onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.retrieveStatistics()))
          }, null, 8, ["label", "modelValue"]),
          _createVNode(_component_va_input, {
            class: "ageOptions",
            type: "number",
            label: _ctx.ageParameter[1].name,
            modelValue: _ctx.ageParameter[1].age,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ageParameter[1].age) = $event)),
            clearable: "",
            onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.retrieveStatistics())),
            rules: [(v) => Number(v) >= Number(_ctx.ageParameter[0].age) || 'Fejl: Maks alder skal være større en min alder']
          }, null, 8, ["label", "modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_va_button, {
              class: "btn",
              rounded: false,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.resetFilter()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  class: "reset",
                  name: "autorenew"
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("table", _hoisted_24, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortStatistics('license')))
                }, "Licens"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sortStatistics('name')))
                }, "Navn"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sortStatistics('club')))
                }, "Klub"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sortStatistics('noMatches')))
                }, "Kampe"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sortStatistics('wonMatches')))
                }, "Vundne"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sortStatistics('winRatio')))
                }, "Vundne %"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sortStatistics('dartingForWonSet')))
                }, "Dart for vundne sæt"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sortStatistics('average')))
                }, "Snit"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sortStatistics('180')))
                }, "180"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.sortStatistics('highestClose')))
                }, "Højeste lukker"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.sortStatistics('fastestDarting')))
                }, "Hurtigste sæt")
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerStatistics, (player, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_25, _toDisplayString(player.license), 1),
                  _createElementVNode("td", {
                    class: "sorting",
                    onClick: ($event: any) => (_ctx.toMemberPage(player.memberId))
                  }, _toDisplayString(player.memberName), 9, _hoisted_26),
                  _createElementVNode("td", null, _toDisplayString(player.clubName), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(player.noMatches), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(player.wonMatches), 1),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(player.winRatio), 1),
                  _createElementVNode("td", _hoisted_30, _toDisplayString(player.dartingForWonSet), 1),
                  _createElementVNode("td", _hoisted_31, _toDisplayString(player.setAverage), 1),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(player.oneEighty), 1),
                  _createElementVNode("td", _hoisted_33, _toDisplayString(player.highestClose), 1),
                  _createElementVNode("td", _hoisted_34, _toDisplayString(player.fastestDarting === 1000 ? '-' : player.fastestDarting), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}